import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../shared/utils.js/axiosConfig";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get Safes
export const getSafes = createAsyncThunk(
  "Safes/getSafes",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search) queryParams.append("search", params.search);
      if (
        params.is_active !== undefined &&
        params.is_active !== null &&
        params.is_active !== ""
      ) {
        queryParams.append("is_active", params.is_active);
      }
      const url = `${BASE_URL}/safes${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axiosInstance.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to get safes!";
      return rejectWithValue(message);
    }
  },
);

// Get Safe Details
export const getSafeDetails = createAsyncThunk(
  "Safes/getSafeDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axiosInstance.get(`${BASE_URL}/safes/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get safe details!";
      return rejectWithValue(message);
    }
  },
);

// Add Safe
export const addSafe = createAsyncThunk(
  "Safes/addSafe",
  async (data, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axiosInstance.post(`${BASE_URL}/safes`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      let message = error.response?.data?.message || "Failed to add safe!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

// Update Safe
export const updateSafe = createAsyncThunk(
  "Safes/updateSafe",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axiosInstance.put(
        `${BASE_URL}/safes/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      let message = error.response?.data?.message || "Failed to update safe!";
      if (error.response?.data?.errors) {
        message = JSON.stringify(error.response.data.errors);
      }
      return rejectWithValue(message);
    }
  },
);

// Toggle Safe Status
export const toggleSafeStatus = createAsyncThunk(
  "Safes/toggleSafeStatus",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axiosInstance.patch(
        `${BASE_URL}/safes/${id}/toggle-status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to toggle safe status!";
      return rejectWithValue(message);
    }
  },
);

// Delete Safe
export const deleteSafe = createAsyncThunk(
  "Safes/deleteSafe",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axiosInstance.delete(`${BASE_URL}/safes/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to delete safe!";
      return rejectWithValue(message);
    }
  },
);
